<template>
  <div>
    <div id="list" v-if="viewType == 'list'">
      <div class="row center-block">
        <div class="col-md-12">
          <div class="box">
            <div class="box-header">
                <label for="recordPerPage" class="col-sm-1 col-md-1 col-lg-1" style="margin-top: 10px; text-align:left">Show</label>
                <div class="col-sm-2 col-md-2 col-lg-1" style="padding-left:0px;">
                  <select v-on:change="changePageSize" ref="recordPerPage" class="form-control">
                    <option v-if="inquiryParam.pageSize == 5" selected>5</option><option v-else>5</option>
                    <option v-if="inquiryParam.pageSize == 10" selected>10</option><option v-else>10</option>
                    <option v-if="inquiryParam.pageSize == 20" selected>20</option><option v-else>20</option>
                    <option v-if="inquiryParam.pageSize == 50" selected>50</option><option v-else>50</option>
                    <option v-if="inquiryParam.pageSize == 100" selected>100</option><option v-else>100</option>
                  </select>
                </div>          
                <div class="box-tools">              
                  <button v-on:click="onCreate" class="btn btn-primary">Create</button>
                  <button v-on:click="inquiry" class="btn btn-warning">Search</button>
                </div>
            </div>        
            <div class="box-body no-padding table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="width: 45px;text-align:center;">#</th>
                    <th style="text-align:center;">Action</th>
                    <th style="text-align:left;">Name</th>
                    <th style="text-align:left;">Description</th>
                    <th style="text-align:left;">Table Name</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in listData" v-bind:key="i">
                    <td style="width:45px;text-align:right;">{{ startSequence + i + 1}}</td>
                    <td style="width:85px;text-align:center;">
                      <a href="#" v-on:click="onDisplay(row)" ref="displayRow" style="padding-right:5px">
                        <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                      </a>
                      <a href="#" v-on:click="onEdit(row)" ref="editRow" style="padding-right:5px">
                        <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                      </a>
                      <a href="#" v-on:click="onDelete(row)" ref="deleteRow" style="padding-right:5px">
                        <span class="icon ion-ios-trash" data-toggle="tooltip" data-placement="right" title="Delete"></span>
                      </a>
                    </td>
                    <td style="text-align:left;">{{ row.name }}</td>
                    <td style="text-align:left;">{{ row.description }}</td>
                    <td style="text-align:left;">{{ row.tableName }}</td>
                    <td hidden>{{ row.id }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="box-footer">
              <div class="form-group">
                <label style="width:25px;text-align:right;">
                    <a href="#"><i v-on:click="changePage(1)" class="icon ion-ios-rewind"></i></a>
                </label>
                <label style="width:35px;text-align:center;">
                    <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
                </label>
                <label>
                    Page
                </label>
                <label>
                    <input v-model="inquiryParam.CurrentPageNumber" v-on:keyup.enter="gotoPage($event)" type="text" class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
                </label>
                <label id="TotalPageText">
                  {{ totalPages }}                
                </label>
                <label style="width:35px;text-align:center;">
                    <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
                </label>
                <label style="width:25px;text-align:left;">
                    <a href="#"><i v-on:click="changePage(totalPages)" class="icon ion-ios-fastforward"></i></a>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div id="form" v-if="viewType == 'form'">
        <div class="row center-block">
          <div class="col-md-12">
            <div class="box box-info">
              <form @submit.prevent class="form-horizontal">
                <div class="box-body">
                  <div class="form-group">
                    <label for="inputName" class="col-sm-2 control-label">Name</label>
                    <div class="col-sm-10">
                      <input :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" placeholder="Authorization Object Name" v-model="formData.name">
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="inputDescription" class="col-sm-2 control-label">Description</label>
                    <div class="col-sm-10">
                      <input :disabled="viewMode == MODE_VIEW" class="form-control" id="inputDescription" placeholder="Authorization Object Description" v-model="formData.description">
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="inputTableName" class="col-sm-2 control-label">Table Name</label>
                    <div class="col-sm-10">
                      <select v-model="formData.tableName" class="form-control" :disabled="viewMode == MODE_VIEW">
                        <option v-for="(row, i) in listTable" v-bind:key="i" v-bind:value="row.id">
                          {{ row.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <input type="hidden" class="form-control" id="inputId" v-model="formData.id">
                </div>
                <!-- /.box-body -->
                <div class="box-footer">
                  <div class="box-tools">
                    <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>
                    <button @click="onCancel()" class="btn btn-warning">Cancel</button>
                    <button v-if="viewMode != MODE_VIEW" @click="onSave()" class="btn btn-info pull-right">Save</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onEdit(formData)" class="btn btn-info pull-right">Edit</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onCreate()" class="btn btn-info pull-right" style="margin-right:15px;">Create</button>
                  </div>
                </div>
                <!-- /.box-footer -->
              </form>
            </div>          
          </div>
        </div>
      </div> 
    </transition>  
  </div>  
</template>

<script>
import api from '../../api'
import SweetAlert from 'sweetalert2'

const VIEW_LIST = 'list'
const VIEW_FORM = 'form'
const MODE_NONE = 'none'
const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'

export default {
  name: 'AuthObject',
  data() {
    return {
      VIEW_LIST: VIEW_LIST,
      VIEW_FORM: VIEW_FORM,
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_CREATE: MODE_CREATE,
      MODE_UPDATE: MODE_UPDATE,
      column: '',
      item: null,
      listData: null,
      totalRows: 0,
      totalPages: 0,
      startSequence: 0,
      inquiryParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'ASC',
        SortExpression: 'Name'
      },
      viewType: VIEW_LIST,
      viewMode: MODE_NONE,
      formData: {
        id: 0,
        name: '',
        description: '',
        tableName: ''
      },
      listTable: undefined
    }
  },
  created() {
    this.viewType = VIEW_LIST
    this.inquiry()
  },
  mounted() {
    this.$refs.recordPerPage.value = this.inquiryParam.PageSize
  },
  methods: {
    changePageSize(evt) {
      this.inquiryParam.PageSize = evt.target.value
      this.inquiryParam.CurrentPageNumber = 1
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    gotoPage(evt) {
      if (evt.target.value > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else if (evt.target.value < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    changePage(page) {
      if (page < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      } else if (page > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else {
        this.inquiryParam.CurrentPageNumber = page
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    inquiry() {
      api
        .request('Account', 'get', '/api/Role/InquiryAuthObject?WhereClause=' + this.inquiryParam.WhereClause +
                                 '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
                                 '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)
        .then(response => {
          var data = response.data
          this.listData = data.entity
          this.total = data.totalRows
          this.totalPages = data.totalPages
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    initForm() {
      this.formData.name = ''
      this.formData.description = ''
      this.formData.tableName = ''
    },
    onCreate() {
      this.initForm()
      this.viewType = VIEW_FORM
      this.viewMode = MODE_CREATE
    },
    getDetail(id) {
      if (id && id !== 0) {
        api
          .request('Account', 'get', '/api/Role/GetDetailAuthObject?Id=' + id, null)
          .then(response => {
            var data = response.data
            this.formData = data.entity
          })
          .then(response => {
            this.getAllTable()
          })
          .catch(error => {
            var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
            SweetAlert.fire('Error', message, 'error')
          })
      }
    },
    getAllTable() {
      api
        .request('Account', 'get', '/api/Role/GetAllTable', null)
        .then(response => {
          var data = response.data
          this.listTable = data.entity
        })
        .then(response => {
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onDisplay(row) {
      this.viewType = VIEW_FORM
      this.viewMode = MODE_VIEW
      this.getDetail(row.id)
    },
    onEdit(data) {
      this.viewType = VIEW_FORM
      this.viewMode = MODE_UPDATE
      this.getDetail(data.id)
    },
    onDelete(data) {
      SweetAlert.fire({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: true
      })
      .then((result) => {
        if (result.value) {
          var res = this.delete(data)
          SweetAlert.fire('Deleted', res.message, res.status)
        } else if (result.dismiss === SweetAlert.DismissReason.cancel) {
          SweetAlert.fire('Cancelled', 'Your data is still exist', 'info')
        }
      })
    },
    onCancel() {
      this.initForm()
    },
    onBack() {
      this.inquiry()
      this.viewType = VIEW_LIST
    },
    onSave() {
      var data = {
        Id: this.formData.id,
        Name: this.formData.name,
        Description: this.formData.description,
        TableName: this.formData.tableName
      }

      var status = 'success'
      var message = ''
      var method = ''
      switch (this.viewMode) {
        case MODE_CREATE:
          method = 'CreateAuthObject'
          break
        case MODE_UPDATE:
          method = 'UpdateAuthObject'
          break
      }

      api
        .request('Account', 'post', '/api/Role/' + method, data)
        .then(response => {
          var resData = response.data
          this.formData = resData.entity
          this.total = resData.totalRows

          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)

          if (resData.returnStatus) {
            this.onDisplay({id: this.formData.id, name: this.formData.name})
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    delete(data) {
      var status = ''
      var message = ''
      var reqData = {
        Id: data.id,
        Name: data.name
      }
      api.request('Account', 'post', '/api/Role/DeleteAuthObject', reqData)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage
          this.inquiry()
        })
        .catch(error => {
          status = 'error'
          message = 'Error happens when call API delete: ' + error.message
        })
      return { status: status, message: message }
    }
  }
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// AuthorizationObject.vue?3198622e